module.exports = __webpack_public_path__ + "img/noNotic.bdcb275d.png";